<div class="group-info-org">
	<!-- Org info -->
	<div>
		<a
			[href]="adminToolsUrl"
			target="_blank"
			translate="group-settings_admin-tools-org-settings">
		</a>
	</div>

	<!-- Accounts -->
	<div id="org-account-list">

		<h4 translate="group-settings_accounts"></h4>

		<!-- Account search -->
		<div class="org-search-container search-bar">
			<div class="input-group" role="search">
				<span class="search-txt" translate="common_search"></span>
				<input
					[attr.aria-label]="'common_search' | translate"
					type="text"
					class="form-control search-input"
					translate
					translate-attr-placeholder="group-settings_search-for-account"
					[ngModel]="accountFilter$ | async"
					(ngModelChange)="onAccountFilterChange($event)"/>
				@if ((accountFilter$ | async) === '') {
					<span class="input-group-addon"><i class="ficon-search"></i></span>
				}
				@if (accountFilter$ | async) {
					<span class="input-group-addon search-clear">
						<button (click)="clearSearch()" aria-label="{{ 'common_cancel-search' | translate }}" class="ficon-app-x btn-none"></button>
					</span>
				}
			</div>
		</div>

		@if (isLoading()) {
			<div class="alert alert-info" translate="common_loading"></div>
		}

		@if (visibleAccounts$ | async; as visibleAccounts) {
			<table class="table">
				<thead>
					@if (user.is_root_user) {
						<th translate="group-settings_id"></th>
					}
					<th translate="group-settings_account-name"></th>
					<th translate="group-settings_owner"></th>
					<th translate="group-settings_users"></th>
					<th translate="group-settings_videos"></th>
					<th
						class="action-header"
						translate="group-settings_action">
					</th>
				</thead>
				<tbody>
					@for (account of visibleAccounts; track account.group_id) {
						<tr
							[class.active]="options.selectedAccount === account"
							(click)="options.selectedAccount = account">
							@if (user.is_root_user) {
								<td>{{ account.group_id }}</td>
							}
							<td>{{ account.name }}</td>
							<td>{{ account.user.full_name }}</td>
							<td>{{ account.num_users }}</td>
							<td>{{ account.num_sessions }}</td>
							<td>
								<a
									class="btn btn-none"
									[matTooltip]="'modal-edit-user_login-as' | translate: {name: account.user.full_name}"
									(click)="loginAs(account.user)">
									<i class="ficon-app-mask ficon-large"></i>
								</a>
							</td>
						</tr>
					}
				</tbody>
			</table>

			@if (!isLoading() && !visibleAccounts.length) {
				<div
					class="alert alert-info"
					translate="group-settings_no-accounts-under"
					[translateParams]="{name: (group.name || 'Unaffiliated Accounts')}">
				</div>
			}
		}

	</div>

</div>
